import { EmptyState } from '@components/empty-state';
import { IconQuestion } from '@components/icons/question';
import { useScopedTranslate } from '@locale/translate';

export const FormResponsePending = () => {
  const { t } = useScopedTranslate(locale);
  return (
    <EmptyState
      header={t('header')}
      content={t('content')}
      variant="small"
      icon={<IconQuestion size={40} />}
    />
  );
};

const locale = {
  en: {
    content: 'Responses will appear here when the form is completed',
    header: 'No responses received',
  },
};
